import { Box, Button, Typography, styled } from '@mui/material'

export const Text1 = styled(Typography)`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
`

export const Text2 = styled(Typography)`
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
`

export const Text3 = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
`

export const Text4 = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
`

export const LeftWrapper = styled(Box)`
  position: relative;
  flex: 1;
  height: fit-content;
  max-width: 812px;

  background: var(--ps-primary_bg);
  border: 1px solid rgba(191, 255, 11, 0.2);

  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 48px;
  @media (max-width: 800px) {
    padding: 20px 13px;
  }
`

export const MinimumAmountWrapper = styled(Box)`
  display: flex;
  align-items: center;
  column-gap: 8px;

  margin-top: 10px;
  align-self: flex-end;
`

export const CheckRowWrapper = styled(Box)`
  display: flex;
  width: 100%;
  padding: 12px;
  align-items: flex-start;
  align-self: flex-start;
  column-gap: 4px;
  background: rgba(250, 81, 111, 0.1);
  margin-top: 40px;
`
export const CheckRowWithdrawWrapper = styled(Box)`
  display: flex;
  /* padding: 12px; */
  align-items: center;
  align-self: flex-start;
  column-gap: 4px;
  margin-top: 40px;
`

export const StyledButton = styled(Button)`
  height: auto;
  padding: 14px 24px;

  background: #bfff0b;
  color: #000;
  border: 1px solid transparent;

  :hover {
    background: transparent;
    border-color: #bfff0b;
    color: #bfff0b;
  }

  &.Mui-disabled {
    color: #000;
    background: rgba(191, 255, 11, 0.5);
  }
`
